import { useState } from "react";
import { toast } from "sonner";
import { FilePdf, WhatsappLogo } from "@phosphor-icons/react";
import { api, formatApiError } from "@/lib/api";
import { QUOTE_TYPES } from "@/lib/dseQuotes";

export default function DseQuoteActions({ type, quote, testPrefix }) {
  const [sending, setSending] = useState(false);
  const base = QUOTE_TYPES[type].base;

  const openPdf = async () => {
    const win = window.open("", "_blank");
    try {
      const resp = await api.get(`${base}/${quote.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
      if (win) win.location.href = url;
      else window.location.href = url;
    } catch (e) {
      if (win) win.close();
      toast.error(formatApiError(e));
    }
  };

  const sendWa = async () => {
    const mobile = quote.customer?.phone || window.prompt("Customer WhatsApp number");
    if (!mobile) return;
    setSending(true);
    try {
      await api.post(`${base}/${quote.id}/send-whatsapp`, { mobile });
      toast.success(`Quote sent to ${mobile}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  const btn = "flex-1 flex items-center justify-center gap-2 py-3 text-sm font-semibold transition-colors active:scale-[0.98]";
  return (
    <div className="flex gap-2">
      <button type="button" onClick={sendWa} disabled={sending} data-testid={`${testPrefix}-whatsapp`}
        className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60`}>
        <WhatsappLogo size={18} weight="fill" /> {sending ? "Sending…" : "WhatsApp"}
      </button>
      <button type="button" onClick={openPdf} data-testid={`${testPrefix}-pdf`}
        className={`${btn} border border-ink text-ink hover:bg-ink hover:text-white`}>
        <FilePdf size={18} weight="bold" /> PDF
      </button>
    </div>
  );
}
